/**
 * Thin admin wrapper over shared createClientLogger (gold FE logger).
 */

import {
  createClientLogger,
  getClientCorrelationId,
  type ClientLoggerMeta,
} from 'pi-kiosk-shared/logging';
import { getRuntimeConfig } from '../../runtimeConfig.js';

export type AppLoggerMeta = ClientLoggerMeta;

/** Prefer runtime-config release; fall back to Vite env for local/Jest. */
function readVersion(): string | undefined {
  const fromRuntime = getRuntimeConfig()?.buildVersion;
  if (typeof fromRuntime === 'string') {
    const trimmed = fromRuntime.trim();
    if (trimmed.length > 0) {
      return trimmed;
    }
  }
  if (typeof process !== 'undefined' && typeof process.env['VITE_BUILD_VERSION'] === 'string') {
    const v = process.env['VITE_BUILD_VERSION'].trim();
    return v.length > 0 ? v : undefined;
  }
  return undefined;
}

export const appLogger = createClientLogger({
  app: 'rpapp-admin',
  getCorrelationId: getClientCorrelationId,
  readVersion,
});
